// src/components/ClientIntro.js
import React from "react";

import { ArrowIcon } from "./Icons";

const reviews = [
  {
    name: "Jaspreet Parmar",
    text:
      "Anand has been our mortgage adviser for more than five years. He’s extremely knowledgeable, professional, and always available when we need him. We recommend him with confidence.",
    tag: "Long-term mortgage client",
  },
  {
    name: "Gurwant Singh",
    text:
      "Very reliable and professional. Anand helped us secure sharp rates and great cash-back, and made the whole lending process straightforward.",
    tag: "Home loan & cash-back",
  },
  {
    name: "Brijesh Patel",
    text:
      "Highly recommend Expert Finance for any mortgage or insurance needs. The team know their stuff and the advice is always clear and practical.",
    tag: "Mortgage & insurance",
  },
  {
    name: "Akash Padayachi",
    text:
      "Anand treated us like family, not just clients. We felt genuinely supported throughout and knew he cared about getting the right result for us.",
    tag: "Family-focused support",
  },
  {
    name: "Avneel Kumar",
    text:
      "I worked with Amit from Expert Finance for my insurance and was very happy with the outcome and the service. Definitely recommend.",
    tag: "Insurance client",
  },
  {
    name: "Gurtej Sandha",
    text:
      "Awesome people. Anand is polite, patient and guided us through each step so we always understood what was happening.",
    tag: "Guidance & service",
  },
  {
    name: "Anil Kumar",
    text:
      "Excellent service. Anand explained every stage of the home loan clearly so the process felt simple instead of stressful. Highly recommend.",
    tag: "First home loan",
  },
];

const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/place/Expert+Finance/@-36.9646867,174.9010332,17z/data=!4m8!3m7!1s0x6d0d4d165155d12f:0x9e4121e5b2e5ff7e!8m2!3d-36.9646867!4d174.9036135!9m1!1b1!16s%2Fg%2F11jzvn2rkp?entry=ttu&g_ep=EgoyMDI1MTEyMy4xIKXMDSoASAFQAw%3D%3D";

const initials = (name) =>
  name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2);

function Stars() {
  return (
    <span className="review-stars" aria-label="5 out of 5 stars">
      {Array.from({ length: 5 }, (_, i) => (
        <svg key={i} width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M12 2.8l2.8 5.9 6.4.8-4.7 4.4 1.2 6.4L12 17.2l-5.7 3.1 1.2-6.4-4.7-4.4 6.4-.8z"
          />
        </svg>
      ))}
    </span>
  );
}

// Two copies of the list in one row; the track slides left by exactly one
// copy and loops, so the strip never runs out (same idea as the bank logos).
const loopedReviews = [...reviews, ...reviews];

function ClientIntro() {
  return (
    <section className="reviews-section">
      <div className="reviews-inner">
        <div className="reviews-head">
          <div>
            <span className="reviews-kicker">Client reviews</span>
            <h2 className="reviews-title">What our clients say.</h2>
          </div>

          <a
            href={GOOGLE_REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="pill-btn pill-btn-ghost"
          >
            Read our reviews on Google
            <ArrowIcon />
          </a>
        </div>
      </div>

      <div className="reviews-marquee">
        <div className="reviews-track">
          {loopedReviews.map((review, idx) => (
            <figure
              className="review-card"
              key={`${review.name}-${idx}`}
              aria-hidden={idx >= reviews.length ? "true" : undefined}
            >
              <Stars />
              <blockquote className="review-text">{review.text}</blockquote>
              <figcaption className="review-author">
                <span className="review-avatar" aria-hidden="true">
                  {initials(review.name)}
                </span>
                <span>
                  <span className="review-name">{review.name}</span>
                  <span className="review-tag">{review.tag}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ClientIntro;
